import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Helmet } from 'react-helmet-async';
export function DmcaPage() {
  return <>
      <Helmet data-id="element-188">
        <title data-id="element-189">DMCA Policy - Fifth Door</title>
        <meta name="description" content="Fifth Door DMCA Policy." data-id="element-190" />
        <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-191" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-192" />
        <link href="https://fonts.googleapis.com/css2?family=Bungee&family=Bricolage+Grotesque:wght@400;500;600;700&family=Instrument+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" data-id="element-193" />
      </Helmet>

      <main className="w-full relative isolate overflow-x-hidden min-h-screen" style={{
      backgroundColor: '#074030'
    }} data-id="element-194">
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: `
              linear-gradient(to right, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 1px, transparent 1px)
            `,
        backgroundSize: '30px 30px',
        backgroundPosition: '0 0'
      }} data-id="element-195" />
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bonQpX7FQKEhKvnQfRNJtT/noise-background.png)',
        backgroundRepeat: 'repeat',
        backgroundSize: '200px 200px',
        opacity: 0.24
      }} data-id="element-196" />

        <div className="absolute top-8 left-8 z-20" data-id="element-197">
          <Link to="/" className="flex items-center gap-3" data-id="element-198">
            <img src="https://cdn.magicpatterns.com/uploads/8dB8M4GqHB66FgPhzt2tyW/Group_44.png" alt="Fifth Door Logo" className="h-8 w-auto object-contain brightness-0 invert" data-id="element-199" />
            <span className="text-white text-lg" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-200">
              FIFTH DOOR
            </span>
          </Link>
        </div>

        <div className="relative z-10 px-6 py-20 md:py-32 max-w-4xl mx-auto" data-id="element-201">
          <h1 className="text-[50px] md:text-[74px] mb-8 text-center" style={{
          fontFamily: 'Bungee, sans-serif',
          color: 'white',
          lineHeight: '1.1'
        }} data-id="element-202">
            DMCA POLICY
          </h1>
          <div className="text-white/70 leading-relaxed text-lg space-y-6" style={{
          fontFamily: "'Instrument Sans', sans-serif"
        }} data-id="element-203">
            <p className="font-bold" data-id="element-204">Last Updated: April 13, 2026</p>

            <p data-id="element-205">
              Fifth Door, Inc. ("Fifth Door," "we," "us," or "our") respects the
              intellectual property rights of others and expects our users to do
              the same. In accordance with the Digital Millennium Copyright Act
              of 1998 ("DMCA"), we will respond expeditiously to claims of
              copyright infringement committed using our services (the
              "Services") if such claims are reported to our designated
              copyright agent identified below.
            </p>

            <h2 className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-206">
              FILING A DMCA NOTICE OF ALLEGED INFRINGEMENT
            </h2>

            <p data-id="element-207">
              If you believe that content hosted on or distributed through the
              Services infringes your copyright, please send a written notice of
              alleged infringement ("DMCA Notice") containing the following
              information to our designated copyright agent:
            </p>

            <ol className="list-decimal pl-6 space-y-3" data-id="element-208">
              <li data-id="element-209">
                A physical or electronic signature of a person authorized to act
                on behalf of the owner of the copyright that has been allegedly
                infringed;
              </li>
              <li data-id="element-210">
                Identification of the copyrighted work claimed to have been
                infringed, or, if multiple copyrighted works are covered by a
                single notification, a representative list of such works;
              </li>
              <li data-id="element-211">
                Identification of the material that is claimed to be infringing
                or to be the subject of infringing activity and that is to be
                removed or access to which is to be disabled, and information
                reasonably sufficient to permit us to locate the material (e.g.,
                a URL or specific description);
              </li>
              <li data-id="element-212">
                Information reasonably sufficient to permit us to contact you,
                such as an address, telephone number, and, if available, an
                email address;
              </li>
              <li data-id="element-213">
                A statement that you have a good faith belief that use of the
                material in the manner complained of is not authorized by the
                copyright owner, its agent, or the law; and
              </li>
              <li data-id="element-214">
                A statement that the information in the notification is
                accurate, and under penalty of perjury, that you are authorized
                to act on behalf of the owner of an exclusive right that is
                allegedly infringed.
              </li>
            </ol>

            <h2 className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-215">
              DESIGNATED COPYRIGHT AGENT
            </h2>

            <p data-id="element-216">
              Please send all DMCA Notices to our designated copyright agent at:
            </p>

            <div className="border border-white/10 rounded-xl p-6 bg-white/5" data-id="element-217">
              <p className="text-white font-semibold" data-id="element-218">Fifth Door, Inc.</p>
              <p data-id="element-219">Attn: DMCA Agent</p>
              <p data-id="element-220">
                Email:{' '}
                <a href="mailto:dmca@fifthdoor.com" className="text-white underline hover:opacity-80" data-id="element-221">
                  dmca@fifthdoor.com
                </a>
              </p>
            </div>

            <h2 className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-222">
              COUNTER-NOTIFICATION
            </h2>

            <p data-id="element-223">
              If you believe that your content was removed or disabled by
              mistake or misidentification, you may submit a written
              counter-notification ("Counter-Notice") to our designated
              copyright agent containing the following information:
            </p>

            <ol className="list-decimal pl-6 space-y-3" data-id="element-224">
              <li data-id="element-225">Your physical or electronic signature;</li>
              <li data-id="element-226">
                Identification of the material that has been removed or to which
                access has been disabled and the location at which the material
                appeared before it was removed or access to it was disabled;
              </li>
              <li data-id="element-227">
                A statement under penalty of perjury that you have a good faith
                belief that the material was removed or disabled as a result of
                mistake or misidentification of the material to be removed or
                disabled; and
              </li>
              <li data-id="element-228">
                Your name, address, and telephone number, and a statement that
                you consent to the jurisdiction of the federal district court
                for the judicial district in which your address is located (or,
                if your address is outside of the United States, for any
                judicial district in which Fifth Door may be found), and that
                you will accept service of process from the person who provided
                the original DMCA Notice or an agent of such person.
              </li>
            </ol>

            <p data-id="element-229">
              Upon receiving a valid Counter-Notice, we will forward it to the
              party who filed the original DMCA Notice. If the original
              notifying party does not file a court action seeking to restrain
              the allegedly infringing activity within ten (10) business days of
              receiving the Counter-Notice, we may restore the removed content.
            </p>

            <h2 className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-230">
              REPEAT INFRINGERS
            </h2>

            <p data-id="element-231">
              It is Fifth Door's policy, in appropriate circumstances, to
              disable and/or terminate the accounts of users who are repeat
              infringers of intellectual property rights, including copyrights.
            </p>

            <h2 className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-232">
              MISREPRESENTATIONS
            </h2>

            <p data-id="element-233">
              Please note that under Section 512(f) of the DMCA, any person who
              knowingly materially misrepresents that material or activity is
              infringing, or that material or activity was removed or disabled
              by mistake or misidentification, may be subject to liability for
              damages, including costs and attorneys' fees.
            </p>

            <h2 className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-234">
              CONTACT
            </h2>

            <p data-id="element-235">
              If you have any questions about this DMCA Policy or wish to report
              copyright infringement, please contact us at:{' '}
              <a href="mailto:dmca@fifthdoor.com" className="text-white underline hover:opacity-80" data-id="element-236">
                dmca@fifthdoor.com
              </a>
              .
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-237" />
    </>;
}